import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';
import type {
  PromoteTargetEnvironment,
  WorkflowPromotePlan,
} from './usePromoteWorkflowTemplate';

export interface WorkflowPromotePreflightResponse {
  workflows: Array<{ key: string; name: string; version: string }>;
  forms: Array<{ key: string; name: string; status: string }>;
  services: Array<{ serviceCompositeId: string; title: string }>;
  /** Absent when the target could not be reached, so the summary still renders. */
  plan?: WorkflowPromotePlan;
}

export const useWorkflowPromotePreflight = (
  workflowTemplateId: string,
  options?: { enabled?: boolean; targetEnvironment?: PromoteTargetEnvironment }
) => {
  const target = options?.targetEnvironment;
  const url = `${BASE_URL}/${workflowTemplateId}/promote/preflight${target ? `?targetEnvironment=${target}` : ''}`;
  const enabled = options?.enabled ?? true;

  const { data, error, isLoading, mutate } =
    useSWR<WorkflowPromotePreflightResponse>(
      enabled ? url : null,
      SWRFetcher({ method: 'GET' })
    );

  return { data, error, isLoading, mutate };
};
